// extracted by mini-css-extract-plugin
export var activeFilterButton = "_jw-c";
export var backButton = "_jw-4";
export var backIcon = "_jw-5";
export var chevronShortcut = "_jw-6";
export var container = "_jw-1";
export var editor = "_jw-8";
export var editorWrapper = "_jw-7";
export var prefix = "_jw-2";
export var searchIcon = "_jw-3";
export var suffix = "_jw-9";
export var suffixContent = "_jw-a";
export var suffixText = "_jw-b";
export var wrapper = "_jw-0";